import { BasicPage } from "../../theme/Component/BasicPage"

export const HistoricoImp =()=>{
    return(
        <h4>Historico</h4>
    )
}